import { Grid, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { NonPersonnelFile as NonPersonnelFileModel, Permission, UploadFile } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { initDataModel } from "utils";
import { NonPersonnelFile } from "./NonPersonnelFile";

export const NonPersonnelFiles = (props: {
  rootPermission: Permission;
  id: number;
  nonPersonnelFiles: NonPersonnelFileModel[];
  setNonPersonnelFiles: (files: NonPersonnelFileModel[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      {props.nonPersonnelFiles.map((nonPersonnelFile, index) => (
        <Grid key={index} item xs={smallFieldBreakpoints}>
          <NonPersonnelFile
            rootPermission={props.rootPermission}
            nonPersonnelFile={nonPersonnelFile}
            setNonPersonnelFile={(nonPersonnelFile) => {
              props.setNonPersonnelFiles(
                produce(props.nonPersonnelFiles, (draft) => {
                  draft[index] = nonPersonnelFile;
                })
              );
            }}
            cancelCreate={() => {
              props.setNonPersonnelFiles(
                produce(props.nonPersonnelFiles, (draft) => {
                  draft.splice(index, 1);
                })
              );
            }}
          />
        </Grid>
      ))}

      <Grid item xs={smallFieldBreakpoints}>
        <FilePanel
          onFileChange={(fileName, fileSize, uploadingData) => {
            const newNonPersonnelFile = initDataModel<NonPersonnelFileModel>({
              uploadFile: initDataModel<UploadFile>({
                fileName: fileName,
                fileSize: fileSize,
                uploadingData: uploadingData,
              }),
            });

            props.setNonPersonnelFiles(
              produce(props.nonPersonnelFiles, (draft) => {
                draft.push(newNonPersonnelFile);
              })
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
